export enum PageLoadTypes {
  PAGE_RELOAD = 'reload',
  LOCAL_HISTORY = 'local',
}

class HistoryService {
  public wouldAddOrRedirect(url: string) {
    const targetLocation = this.parseUrl(this.cleanUrl(url));
    const currentLocation = this.parseUrl(this.cleanUrl(window.location.href));
    if (currentLocation.pathname !== targetLocation.pathname || currentLocation.hostname !== targetLocation.hostname) {
      return PageLoadTypes.PAGE_RELOAD;
    } else {
      return PageLoadTypes.LOCAL_HISTORY;
    }
  }

  public addOrRedirect(url: string): PageLoadTypes.LOCAL_HISTORY | PageLoadTypes.PAGE_RELOAD {
    const result = this.wouldAddOrRedirect(url);
    if (result === PageLoadTypes.PAGE_RELOAD) {
      window.location.href = url;
    } else if (result === PageLoadTypes.LOCAL_HISTORY) {
      this.add(url);
    }
    return result;
  }

  public add(url: string) {
    const targetLocation = this.parseUrl(this.cleanUrl(url));
    const currentLocation = this.parseUrl(this.cleanUrl(window.location.href));
    if (currentLocation.href !== targetLocation.href) {
      window.history.pushState({}, '', targetLocation.href);
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  }

  public parseUrl(url: string) {
    let urlObject = document.createElement('a');
    urlObject.href = url;
    return {
      href: urlObject.href,
      pathname: urlObject.pathname,
      search: urlObject.search,
      hostname: urlObject.hostname,
      protocol: urlObject.protocol,
    };
  }

  public addArgumentToUrl(url: string, additonalArgument: string) {
    let urlObject = document.createElement('a');
    urlObject.href = url;
    urlObject.search += (urlObject.search.indexOf('?') === -1 ? '?' : '&') + additonalArgument;
    return urlObject.href;
  }

  public cleanUrl(url: string): string {
    let urlObject = document.createElement('a');
    urlObject.href = url;
    return urlObject.href;
  }
}

export const History = new HistoryService();
